import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Page from '../../components/Page';
import {
  VERIFY_OWNER_PATH,
  NOT_FOUND_PATH,
  whiteLabelPath,
} from '../../constants';
import { redirectTo } from '../../actions/config';
import { getVerifyOwnerToken } from '../../helpers/userStorage';

class VerifyGiftcardOwnerRedirect extends React.Component {
  async componentDidMount() {
    const { dispatch, salesChannel } = this.props;
    const { exportType, token, pin } = getVerifyOwnerToken();

    const { id, showWhiteLabelLogoUrl } = salesChannel;
    const verifyOwnerPath = showWhiteLabelLogoUrl
      ? whiteLabelPath(id, VERIFY_OWNER_PATH)
      : VERIFY_OWNER_PATH;

    const pinPath = pin ? `/${pin}` : '';
    const pathname =
      exportType && token
        ? `${verifyOwnerPath}/${exportType}/${token}${pinPath}`
        : NOT_FOUND_PATH;
    await dispatch(redirectTo({ pathname }));
  }

  render() {
    return <Page loading />;
  }
}

VerifyGiftcardOwnerRedirect.propTypes = {
  dispatch: PropTypes.func.isRequired,
  salesChannel: PropTypes.shape({
    id: PropTypes.string,
    showWhiteLabelLogoUrl: PropTypes.string,
  }).isRequired,
};

const mapState = state => ({
  salesChannel: state.config.salesChannel,
});

export default connect(mapState)(VerifyGiftcardOwnerRedirect);
